import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { searchStep } from '../../features/searchStepChange'
import { changePopupData } from '../../features/showPopup'
import HiddenAudio from '../gobal/Popup/HiddenAudio'
import Popup from '../gobal/Popup/Popup'
import DemoSearchResult from '../gobal/SearchResult/DemoSearchResult'
import GlobalLayout from '../layout/GlobalLayout'
import TopMenu from '../layout/TopMenu'
import { UserStatusGoPage } from '../lib/userStatus'

export default function DemoResult() {
    UserStatusGoPage("/demo-result")
    const dispatch = useDispatch()
    let navigate = useNavigate();

    useEffect(() => {
        // if we play come to result page empty data so we can open popups and play audio 
        dispatch(changePopupData({
            video: '',
            image: '',
            open: false,
            audio: '',
            playAudio: false,
            activeAudio: ''
        }))
    }, [])
    // click on number to go search step
    function changeStep(step1, step2, step3) {
        dispatch(searchStep({
            step1: step1,
            step2: step2,
            step3: step3
        }))
        navigate("/search");
    }
    return (
        <GlobalLayout showTopMenu={false} >
            {/* popup for audio and video  */}
            <Popup />
            {/* hidden audio player */}
            <HiddenAudio />
            <TopMenu />
            <div className='pl-10 pr-5 mt-2'>
                <div className='flex font-firstFont text-sm tracking-wider'>
                    <div className='pr-5 border-r-2'>
                        <NavLink to={'/'} className='flex items-center opacity-60'>
                            <img src="/images/icons/back.svg" alt="back" />
                            <span className='ml-[0.625rem]'>Dashboard</span>
                        </NavLink>
                    </div>
                    <div className='flex ml-7'>
                        <div onClick={() => changeStep(true, false, false)} className="cursor-pointer">
                            Step 1 Month /
                        </div>
                        <div className='ml-2 cursor-pointer' onClick={() => changeStep(true, true, false)}>
                            Step 2 Type /
                        </div>
                        <div className='ml-2 cursor-pointer' onClick={() => changeStep(true, true, true)}>
                            Step 3 Question
                        </div>
                    </div>
                </div>
                <DemoSearchResult />
            </div>
        </GlobalLayout>
    )
}
